export default function ContactSection() {
  return (
    <section className="relative w-full py-28 md:py-36 px-6 md:px-10">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <div className="section-divider mb-8"></div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-foreground-950 mb-8">
            Contact
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-8 gap-x-16">
          <div className="space-y-6">
            <div>
              <p className="text-xs uppercase tracking-widest text-foreground-400 font-medium mb-2">Address</p>
              <p className="text-base text-foreground-700 font-light leading-relaxed">
                Ap. Nr. 451 Camera 1
              </p>
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-foreground-400 font-medium mb-2">City</p>
              <p className="text-base text-foreground-700 font-light">Banloc</p>
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-foreground-400 font-medium mb-2">Postal Code</p>
              <p className="text-base text-foreground-700 font-light">307010</p>
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-foreground-400 font-medium mb-2">Country</p>
              <p className="text-base text-foreground-700 font-light">Romania</p>
            </div>
          </div>

          <div className="space-y-6">
            <div>
              <p className="text-xs uppercase tracking-widest text-foreground-400 font-medium mb-2">Phone</p>
              <p className="text-base text-foreground-700 font-light">+40 778129695</p>
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-foreground-400 font-medium mb-2">Email</p>
              <p className="text-base text-foreground-700 font-light">ceo@hersamedia.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}